import { useContext, useEffect, useState } from "react";
import "./style.css";

import { GlobalContext } from "../../context/Provider";
import TableComponent from "../../components/TableComponent";
import LoadingComponent from "../../components/Loading";
import { getHistoricos } from "../../context/actions/movCajaMedico/getHistoricos";
import { Button } from "semantic-ui-react";
import { tableHeadersData } from "./tableHeadersData";

const tableHeaders = tableHeadersData;
const Historicos = () => {
  const { historicoDispatch, historicoState } = useContext(GlobalContext);
  const [pdf, setPdf] = useState(null);

  useEffect(() => {
    getHistoricos()(historicoDispatch);
    // eslint-disable-next-line
  }, []);

  const handleIconclick = (header, data) => {
    if (header === "comprobante") {
      setPdf("data:application/pdf;base64," + encodeURI(data.factura));
    }
  };

  return (
    <div className="wrap">
      <h4>
        Detalle de facturas enviadas a los pacientes en los últimos 60 días.
      </h4>
      <small>
        Puede demorar un minuto o dos el reflejar en el histórico una factura
        recientemente procesada
      </small>
      {historicoState.historico.loading && <LoadingComponent />}
      {!historicoState.historico.loading && !historicoState.historico.error && (
        <div>
          {historicoState.historico.data && (
            <>
              <TableComponent
                tableData={historicoState.historico.data}
                tableHeaders={tableHeaders}
                tableFooters={true}
                striped
                sortable
                celled
                handleIconclick={handleIconclick}
              />
            </>
          )}
        </div>
      )}
      {!historicoState.historico.loading && historicoState.historico.error && (
        <div className="Error">
          <h1>
            Hubo un error al obtener las facturas del sistema. Por favor intente
            nuevamente
          </h1>
          <Button
            basic
            color="red"
            onClick={() => {
              getHistoricos()(historicoDispatch);
            }}
          >
            Reintentar
          </Button>
        </div>
      )}
      {pdf && <iframe src={pdf} title="Pdfviewer" />}{" "}
    </div>
  );
};

export default Historicos;
